import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    eventViewLoading: false,
    event_view: null
}

const viewEventSlice = createSlice({
    name: "event-view",
    initialState,

    reducers: {

        eventViewLoading: (state, action) => {
            state.eventViewLoading = action.payload
        },

        eventViewSingleItem: (state, { payload }) => {
            state.event_view = payload
            state.eventViewLoading = false
        }

    }
})

export const {
    eventViewLoading,
    eventViewSingleItem
} = viewEventSlice.actions
export default viewEventSlice.reducer